import { AssetHistoryProps, AssetHistoryEditorProps } from './AssetHistory.types';

/**
 * 자산 내역 컴포넌트 props 어댑터
 * 원본 props를 새로운 형식으로 변환합니다.
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 새로운 컴포넌트용 props
 */
export function adaptAssetHistoryProps(originalProps: any): AssetHistoryProps {
  // 원본 데이터 확인 및 기본값 설정
  const originalContent = originalProps?.content || {};
  const originalComponentProps = originalProps?.componentProps || {};
  
  // 기존 클래스명 (여러 경로에서 확인)
  const className = originalProps?.className || 
                   originalComponentProps?.className || 
                   "mileage-history-wrapper padding-tb-40";

  // 제목 텍스트 (여러 경로에서 확인)
  const title = originalContent?.title || 
               originalComponentProps?.title || 
               "자산 내역";
  
  // 내역 없음 메시지 (여러 경로에서 확인)
  const emptyText = originalContent?.emptyText || 
                   originalComponentProps?.emptyText || 
                   "자산 내역이 없습니다.";
  
  // 스타일 병합 (인라인 스타일 우선, 필요하면 defaultStyle 추가)
  const style = {
    ...(originalProps?.style || {}),
    ...(originalComponentProps?.style || {})
  };

  // 변환된 props 반환
  const adaptedProps: AssetHistoryProps = {
    id: originalProps?.id || '',
    style,
    className,
    isPreview: originalProps?.isPreview || false,
    componentProps: {
      ...originalComponentProps,
      title,
      emptyText,
      className
    },
    content: {
      ...originalContent,
      title,
      emptyText
    }
  };

  // 다른 원본 props 속성 복사 (이미 처리된 속성은 제외)
  const excludeKeys = ['content', 'style', 'className', 'componentProps', 'id', 'isPreview'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 에디터용 props 어댑터
 * 
 * @param originalProps 기존 에디터 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptAssetHistoryEditorProps(originalProps: any): AssetHistoryEditorProps {
  // 기본 props 어댑터 사용
  const adaptedProps = adaptAssetHistoryProps(originalProps);
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 